import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { array } from 'prop-types'

const DashboardChart = ({ postagens }) => {
  const [series, setSeries] = useState([])

  const init = async posts => {
    setSeries(posts)
  }

  useEffect(() => {
    init(postagens)
  }, [postagens])

  const options = {
    chart: {
      type: 'line',
      stacked: false,
      toolbar: {
        show: false
      },
      offsetX: 3,
      width: '50%'
    },

    dataLabels: {
      enabled: false
    },
    colors: [
      '#185273',
      '#00975C',
      '#9D2AAF',
      '#BA2B2B',
      '#EA9027',
      '#FF00FF',
      '#006400',
      '#00BFFF',
      '#8B4513',
      '#D2691E',
      '#FFD700',
      '#483D8B',
      // '#EE82EE',
      // '#B8860B',
      '#00FA9A'
    ],

    stroke: {
      width: 2.2
    },
    markers: {
      size: 4,
      // colors: ['#000524'],
      strokeColor: '#000524',
      strokeWidth: 1.3
    },
    plotOptions: {},
    xaxis: {
      categories: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
      ]
    },
    yaxis: [
      {
        title: {
          text: 'Número de Leituras',
          offsetX: -7,
          style: {
            color: '#185273',
            fontSize: '16px'
          }
        }
      }
    ],
    tooltip: {
      shared: false,
      intersect: true,
      x: {
        show: false
      },
      y: {
        formatter: val => {
          return val
        }
      }
    },
    legend: {
      horizontalAlign: 'left',
      offsetX: 0
    }
  }

  return (
    <>
      <div
        style={{
          height: '52.5vh',
          padding: '0.2rem'
        }}
      >
        <Chart
          options={options}
          series={series}
          height="100%"
          style={{ marginTop: '0%' }}
        />
      </div>
    </>
  )
}

DashboardChart.propTypes = {
  postagens: array,
  posts: array
}

export default DashboardChart
